export default "__VITE_ASSET__gEhCdPBm__"